module.exports = __webpack_public_path__ + "assets/img/researchbg.5aa1f436.png";